import { EventEmitter } from '../utils';

export const HMSEventEmitter = new EventEmitter();
